import { forwardRef, memo } from 'react'
import { type CustomContentProps, SnackbarContent } from 'notistack'
import styled, { css } from 'styled-components'

import SnackbarRest from '~/shared/assets/icons/SnackbarRest'
import SnackbarSuccess from '~/shared/assets/icons/SnackbarSuccess'

// 스타일 정의
const snackbarStyles = css`
  display: flex;
  flex-flow: row pre-wrap;
  gap: 10px;
  align-items: center;
  justify-content: start;

  box-sizing: border-box;
  width: fit-content;
  height: auto;
  padding: 0 20px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 21px;
  font-weight: 400;
  line-height: 29px;
  color: white;
  word-wrap: break-word;

  background-color: #313634;
  border-radius: 20px;

  /* box-shadow:
    0 3px 5px -1px rgb(0 0 0 / 20%),
    0 6px 10px 0 rgb(0 0 0 / 14%),
    0 1px 18px 0 rgb(0 0 0 / 12%); */

  &.default {
    background-color: #313634;
  }

  &.success {
    background-color: #8bd2d7;
  }

  &.error {
    background-color: #fa6b6b;
  }

  &.warning {
    background-color: #ff9800;
  }

  &.info {
    background-color: #2196f3;
  }
`

const Message = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 8px 0;
`

const StyledSnackbarContent = styled(SnackbarContent)`
  ${snackbarStyles}
`

const Snackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, forwardedRef) => {
    const { message, variant } = props

    return (
      <StyledSnackbarContent ref={forwardedRef} className={variant}>
        {variant === 'success' ? (
          <SnackbarSuccess color="white" />
        ) : (
          <SnackbarRest color="white" />
        )}
        <Message>{message}</Message>
      </StyledSnackbarContent>
    )
  },
)

export default memo(Snackbar)
